export default "__VITE_PUBLIC_ASSET__48cf04d5__"